export default __webpack_public_path__ + "static/media/how-it-work3-grey.e1a8d377.svg";